var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListMemoryPurpleBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "y1ftptiepa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.482353 0 0 0 0 0.309804 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "1abatr7izb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.529412 0 0 0 0 0.576471 0 0 0 0 0.639216 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    filter: "url(#y1ftptiepa)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)",
    filter: "url(#1abatr7izb)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#806FBD",
    strokeLinejoin: "round",
    d: "m8.605 18.228 14.29-8.25 3 5.196-14.29 8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#806FBD",
    strokeLinejoin: "round",
    d: "m12.255 23.049 12.99-7.5 1.5 2.598-12.99 7.5z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#806FBD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.328 18.676 1.3-.75.75 1.3-1.3.75zM14.926 17.176l1.3-.75.75 1.3-1.3.75zM17.525 15.676l1.299-.75.75 1.3-1.3.75zM20.123 14.176l1.299-.75.75 1.3-1.3.75z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListMemoryPurpleBig);
export default __webpack_public_path__ + "static/media/ico-vpc-list-memory-purple-big.948da565d58dcf74e8c8b54ca68e2959.svg";
export { ForwardRef as ReactComponent };